import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "src/shared/modules/header/Header";
import Menu from "src/shared/modules/menu/Menu";

const SalonLayout: React.FC = () => {
  const [pageTitle, setPageTitle] = useState("Home"); // ✅ default title

  return (
    <div className="flex flex-col h-screen">
      
      {/* HEADER */}
      <Header Header={pageTitle} />

      {/* BODY */}
      <div className="flex flex-1 overflow-hidden">
        <Menu />

        <main className="flex-1 overflow-auto bg-white">
          {/* ✅ Provide context safely */}
          <Outlet context={{ setPageTitle }} />
        </main>
      </div>
    </div>
  );
};

export default SalonLayout;